@switch (operator()) {
  @case ('empty') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="4" y="6" width="16" height="12" rx="2" stroke-dasharray="0.1 4.2"/>
    </svg>
  }
  @case ('notEmpty') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="4" y="6" width="16" height="12" rx="2"/>
      <path d="M8 11h8"/>
      <path d="M8 15h5"/>
    </svg>
  }
  @case ('equals') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 9h14"/>
      <path d="M5 15h14"/>
    </svg>
  }
  @case ('notEquals') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 9h14"/>
      <path d="M5 15h14"/>
      <path d="M6 18 18 6"/>
    </svg>
  }
  @case ('in') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M8 5H4.5v14H8"/>
      <path d="M16 5h3.5v14H16"/>
      <circle cx="8.7" cy="12" r="1.15" fill="currentColor" stroke="none"/>
      <circle cx="12" cy="12" r="1.15" fill="currentColor" stroke="none"/>
      <circle cx="15.3" cy="12" r="1.15" fill="currentColor" stroke="none"/>
    </svg>
  }
  @case ('notIn') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M8 5H4.5v14H8"/>
      <path d="M16 5h3.5v14H16"/>
      <circle cx="8.7" cy="12" r="1.15" fill="currentColor" stroke="none"/>
      <circle cx="12" cy="12" r="1.15" fill="currentColor" stroke="none"/>
      <circle cx="15.3" cy="12" r="1.15" fill="currentColor" stroke="none"/>
      <path d="M5 19 19 5"/>
    </svg>
  }
  @case ('true') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 12.5 10 17.5 19 6.5"/>
    </svg>
  }
  @case ('false') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M6.5 6.5 17.5 17.5"/>
      <path d="M17.5 6.5 6.5 17.5"/>
    </svg>
  }
  @case ('startsWith') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="9" width="18" height="6" rx="3"/>
      <rect x="5" y="10.5" width="6" height="3" rx="1.5" fill="currentColor" stroke="none"/>
    </svg>
  }
  @case ('endsWith') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="9" width="18" height="6" rx="3"/>
      <rect x="13" y="10.5" width="6" height="3" rx="1.5" fill="currentColor" stroke="none"/>
    </svg>
  }
  @case ('contains') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="9" width="18" height="6" rx="3"/>
      <rect x="9" y="10.5" width="6" height="3" rx="1.5" fill="currentColor" stroke="none"/>
    </svg>
  }
  @case ('notContains') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="9" width="18" height="6" rx="3"/>
      <rect x="9" y="10.5" width="6" height="3" rx="1.5" fill="currentColor" stroke="none"/>
      <path d="M5 18.5 19 5.5"/>
    </svg>
  }
  @case ('like') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4.5 13.5C6 10 10 10 11.5 13.5 13 17 17 17 18.5 13.5"/>
    </svg>
  }
  @case ('greaterThan') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M8 5 16 12 8 19"/>
    </svg>
  }
  @case ('lessThan') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M16 5 8 12 16 19"/>
    </svg>
  }
  @case ('greaterThanOrEqual') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M8 4 16 9.5 8 15"/>
      <path d="M8 19 16 19"/>
    </svg>
  }
  @case ('lessThanOrEqual') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M16 4 8 9.5 16 15"/>
      <path d="M8 19 16 19"/>
    </svg>
  }
  @case ('between') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 12h16"/>
      <circle cx="8" cy="12" r="2.6" fill="currentColor" stroke="none"/>
      <circle cx="16" cy="12" r="2.6" fill="currentColor" stroke="none"/>
    </svg>
  }
  @case ('before') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="17" cy="12" r="2.6"/>
      <path d="M14 12H6"/>
      <path d="M8.5 9 5 12 8.5 15"/>
    </svg>
  }
  @case ('after') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="7" cy="12" r="2.6"/>
      <path d="M10 12h8"/>
      <path d="M15.5 9 19 12 15.5 15"/>
    </svg>
  }
  @case ('beforeOrEquals') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="17" cy="12" r="2.6" fill="currentColor" stroke="none"/>
      <path d="M14 12H6"/>
      <path d="M8.5 9 5 12 8.5 15"/>
    </svg>
  }
  @case ('afterOrEquals') {
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="7" cy="12" r="2.6" fill="currentColor" stroke="none"/>
      <path d="M10 12h8"/>
      <path d="M15.5 9 19 12 15.5 15"/>
    </svg>
  }
  @default {

  }
}
